import { ScreenContainer } from 'components';
import { useTranslation } from 'react-i18next';
import image from 'assets/images/forgot-password-success.svg';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Space, Typography } from 'antd';

const StyledImage = styled.img`
  height: 70%;
`;

export const InviteDependentSuccessPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  function onSubmit() {
    navigate('/profile', { replace: true });
  }

  return (
    <ScreenContainer>
      <Space direction="vertical" align="center">
        <StyledImage src={image} alt="" />

        <Typography.Title level={3}>{t('profile.sendInviteSuccess')}</Typography.Title>
        <Typography.Text type="secondary">{t('profile.sendInviteEmail')}</Typography.Text>

        <Button type="primary" data-testid={'submitButton'} onClick={onSubmit} style={{ marginTop: 16 }}>
          {t('profile.returnToProfile')}
        </Button>
      </Space>
    </ScreenContainer>
  );
};
